import { toast } from 'sonner';

export const getErrorMessage = (error, fallback = 'Error desconegut') => {
  console.error('Error details:', error);
  if (error.response?.data?.detail) return error.response.data.detail;
  if (error.response?.data?.message) return error.response.data.message;
  if (error.message) return error.message;
  if (typeof error === 'string') return error;
  return fallback;
};

export const showError = (error, fallback = 'Error desconegut') => {
  const message = getErrorMessage(error, fallback);
  toast.error(message);
};

export const showSuccess = (message) => {
  toast.success(message);
};
